import { useEffect, useState } from 'react';

import { useErrorToast } from '../components/Toast';
import { getLinkToken } from '../services/plaidService';

const usePlaidLinkToken = ({
  paymentMethodId,
  itemId,
  manualMicrodepositsFlow = false,
  updateMode = false,
} = {}) => {
  const [linkToken, setLinkToken] = useState(null);

  const showErrorMessage = useErrorToast();

  const getAndSetLinkToken = async (displayToast = false) => {
    if (displayToast) {
      showErrorMessage('Token expired, please try again.');
    }
    const token = await getLinkToken({
      paymentMethodId,
      manualMicrodepositsFlow,
      updateMode,
      itemId,
    });
    setLinkToken(token);
  };

  useEffect(() => {
    getAndSetLinkToken();
  }, [paymentMethodId, manualMicrodepositsFlow, updateMode]);

  return { linkToken, retrySettingLinkToken: getAndSetLinkToken };
};

export default usePlaidLinkToken;
